import { Injectable } from "@angular/core";
import { DataModel, MetaModel, WidgetModel } from "common/models/utility-models/base-model";
import { FormWidgetService } from "../form-widget.service";
import { ResetForgotPasswordModel } from "common/models/page-models/Login/reset-password/reset-password-data-model";
import { ResetPasswordMetaModel } from "common/models/page-models/Login/reset-password/reset-password-form-meta-model";
import { ResetForgotPasswordFormDataService } from "common/services/data-services/admin/login/reset-password/reset-forgot-passward-form.data.service";



@Injectable({
    providedIn: 'root'
})
export class ResetForgotPasswordFormWidgetService extends FormWidgetService<ResetForgotPasswordModel> {
    constructor(protected ds: ResetForgotPasswordFormDataService) {
        super(ds);
    }
    getMetaModel(): MetaModel {
        const meta = new ResetPasswordMetaModel();
        return meta.getMetaModel();
    }
}
